<div class="flex flex-col gap-2" [ngClass]="touched && invalid ? 'my-2' : ''">
  @if (ngControl && touched && invalid) {
    <div id="validation-error-text">
      @if (currentErrors | containsKey: 'required') {
        <pay-form-error [id]="'required-form-error' + ngControlName">{{ 'common.errors.required_field' | translate }}</pay-form-error>
      } @else if (currentErrors | containsKey: 'minlength') {
        <pay-form-error [id]="'minlength-form-error' + ngControlName">
          {{ 'common.errors.min' | translate }}
          {{ getError('minlength')?.requiredLength }}
          {{ 'common.errors.tokens' | translate }}
        </pay-form-error>
      } @else if (currentErrors | containsKey: 'maxlength') {
        <pay-form-error [id]="'maxlength-form-error' + ngControlName">
          {{ 'common.errors.max' | translate }}
          {{ getError('maxlength')?.requiredLength }}
          {{ 'common.errors.tokens' | translate }}
        </pay-form-error>
      } @else if ((currentErrors | containsKey: 'email') || (currentErrors | containsKey: 'invalidEmail')) {
        <pay-form-error [id]="'email-form-error' + ngControlName">{{ 'common.invalid_email' | translate }}</pay-form-error>
      } @else if (currentErrors | containsKey: 'requiredtruewithmessage') {
        <pay-form-error [id]="'form-error' + ngControlName">{{ getError('requiredtruewithmessage') | translate }}</pay-form-error>
      } @else if (currentErrors | containsKey: 'patternwithmessage') {
        <pay-form-error [id]="'form-error' + ngControlName">{{ getError('patternwithmessage') | translate }}</pay-form-error>
      } @else if (currentErrors | containsKey: 'pattern') {
        <pay-form-error [id]="'pattern-form-error' + ngControlName">{{ 'common.errors.pattern' | translate }}</pay-form-error>
      } @else if (currentErrors | containsKey: 'arraylength') {
        <pay-form-error [id]="'arraylen-form-error' + ngControlName">{{ 'common.errors.arraylength' | translate }}</pay-form-error>
      } @else if (currentErrors | containsKey: 'invalidPartnerCode') {
        <pay-form-error [id]="'form-error' + ngControlName">{{ 'common.errors.invalid-partner-code' | translate }}</pay-form-error>
      } @else if (currentErrors | containsKey: 'invalidPostalCode') {
        <pay-form-error class="min-w-max" [id]="'form-error' + ngControlName">
          {{ 'registration_flow.company_details.terms_and_conditions.company_postal_code.invalid' | translate }}
        </pay-form-error>
      } @else if (currentErrors | containsKey: 'minDateException') {
        <pay-form-error class="min-w-max" [id]="'form-error' + ngControlName">
          {{ 'common.errors.min-date' | translate }}
          {{ getError('minDateException') }}
        </pay-form-error>
      } @else if (currentErrors | containsKey: 'maxDateException') {
        <pay-form-error class="min-w-max" [id]="'form-error' + ngControlName">
          {{ 'common.errors.max-date' | translate }}
          {{ getError('maxDateException') }}
        </pay-form-error>
      } @else if (currentErrors | containsKey: 'inValidDate') {
        <pay-form-error class="min-w-max" [id]="'form-error' + ngControlName">
          {{ 'common.errors.invalid-date' | translate }}
        </pay-form-error>
      } @else if (ngControl | hasControlError) {
        <pay-form-error [id]="'form-error' + ngControlName">{{ 'common.errors.invalid-field' | translate }}</pay-form-error>
      }
    </div>
  }
</div>
